export default function (instance) {
    return {
        Get() {
            return instance.get('/SprBasePrices');
        },
    }
}
